









































import { Component, Vue, Prop } from 'vue-property-decorator'
import { ExStore } from 'vuex'

@Component({})
export default class LoginForm extends Vue {
  $store!: ExStore
  username = ''
  password = ''
  error = false

  @Prop(String) homePathname!: string

  async login() {
    try {
      this.error = false
      await this.$store.dispatch('user/login', {
        username: this.username,
        password: this.password
      })
      let redirectTo: string | null
      if (typeof this.$route.query['redirect_to'] === 'object') {
        redirectTo = this.$route.query['redirect_to'][0]
      } else {
        redirectTo = this.$route.query['redirect_to']
      }
      if (typeof redirectTo === 'string') {
        this.$router.push(redirectTo)
      } else {
        this.$router.push({ name: this.homePathname })
      }
    } catch (e) {
      this.error = true
    }
  }

  async refresh() {
    try {
      await this.$store.dispatch('user/refreshToken')
    } catch (e) {
      console.error(e)
    }
  }
}
